import { render, staticRenderFns } from "./COA-OilShxto.vue?vue&type=template&id=34e7f4a6&scoped=true&"
import script from "./COA-OilShxto.vue?vue&type=script&lang=js&"
export * from "./COA-OilShxto.vue?vue&type=script&lang=js&"
import style0 from "./COA-OilShxto.vue?vue&type=style&index=0&id=34e7f4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e7f4a6",
  null
  
)

export default component.exports